import { render, staticRenderFns } from "./King.vue?vue&type=template&id=4982de46&scoped=true"
import script from "./King.vue?vue&type=script&lang=js"
export * from "./King.vue?vue&type=script&lang=js"
import style0 from "./King.vue?vue&type=style&index=0&id=4982de46&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4982de46",
  null
  
)

export default component.exports